<template>
    <div class="details_main">
        <!--展示物カードの表示-->
        <div class="details_item">
            <b-card-group deck class="item-group">
                <!--展示物カード-->
                <draggable v-model="items">
                    <!-- <b-card class="item-card border border-success" v-for="(item, index) in items" :key="index" :img-src="item.url" img-alt="item-img" img-width="130px" img-height="130px" @click.prevent="show(item, index)" img-top @onerror="defaultImg"> -->
                    <b-card class="item-card border border-success" v-for="(item, index) in items" :key="index" :img-src="item.url" img-alt="item-img" img-width="130px" img-height="130px" @click.prevent="show(item, index)" img-top>
                        <b-card-text text-tag="span">
                            <ul>
                                <li>{{item.name | ellipsis}}</li>
                                <li><span style="color: grey; font-size: 12px">{{item.country| ellipsis}}({{item.position}})</span></li>
                                <li v-for="(text, index) in item.main" :key="index">{{text}}</li>
                            </ul>
                        </b-card-text>                                                                                
                    </b-card>
                </draggable>
            </b-card-group>
        </div>
        
        <div class="details_other">
            <!--みんぱくマップ-->
            <div class="map">
                <div v-for="item in items" :key="item.id" class="Block" :class="[item.style]">{{ item.position }}</div>
                <div v-for="item in recommend" :key="item.id"><div v-if="item.position" class="testBlock" :class="[item.style]">{{ item.position }}</div></div>
            </div>
            <!-- <div class="recommend"> -->
            <!--重要度の高い語の表示-->
            <div class="other_keyword" v-show="isKeyword">
                <span>重要度が高い語</span> 
                <div class="keywords">
                    <div class="keyword" v-for="(recommendword, index) in keywords" :key="index">
                        <a href="#" @click="selectRecommend(recommendword)">{{recommendword}}</a>
                    </div>
                </div>
            </div>
            <!--推薦した展示物の表示画面-->
            <div class="recommend-items" v-show="isRecommend">
                <span class="recommendkey">{{this.recommendkey}}</span><span>とも関連している展示物</span> 
                <a href="#" class="noprint" @click="showKeyword">(戻る)</a>
                <div class="recommend-eare">
                    <div class="recommend-item" v-for="(item, index) in recommend" :key="index">
                        <div class="item_img">
                            <b-img :src="item.url"></b-img>
                        </div>
                        <div class="item_text">
                            <ul>
                                <li>{{item.name | recellipsis}}</li>
                                <li>{{item.country | recellipsis}}</li>
                                <li v-if="item.position">({{item.position}})</li>
                            </ul>
                        </div> 
                    </div>
                </div>
            </div>
            <!-- </div> -->
        </div>
        <dialogbar :exhibitdirt="exhibitdirt" @changedirt="changedirt"></dialogbar>
        <keep-alive><recommenddialog ref="recommenderar" :recommendkey="recommendkey" @showRecommend="showRecommend"></recommenddialog></keep-alive>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import dialogbar from './dialog.vue'
    import recommenddialog from './recommenddialog'
    // import data from '../../assets/data.json'

    export default {
        components: {
            draggable,
            dialogbar,
            recommenddialog
        },
        props: {
            exhibits: {
                type: Array
            },
            keyslist: {
                type: Array
            },
        },
        updated() {
            window.console.log(this.items);
        },
        data () {
            return{
                items: this.exhibits,
                keywords: this.keyslist,
                exhibitdirt: {},
                sendVal: false,
                exhibit: [],
                memolist: [],
                recommendkey: "",
                itemindex: Number,
                otherlist: [],
                defaultImg: 'this.src="' + require('../../assets/img/noimgae.png') + '"',
                isKeyword: true,
                isRecommend: false,
                isRecommenddialog: false,
                recommend: [],
            }
        },
        
        //各展示物情報から「その他の関連語」の結合
        created() {
            for (var item of this.items) {
                this.otherlist = this.otherlist.concat(item.other)
            }
            window.console.log("this is otherlist")
            window.console.log(this.otherlist)
        },
        filters: {
            ellipsis (value) {
                if (!value) return ''
                if (value.length > 8) {
                    return value.slice(0, 7) + '...'
                }
                return value
            },
            recellipsis (value) {
                if (!value) return ''
                if (value.length > 8) {
                    return value.slice(0, 6) + '...'
                }
                return value
            },
        },
        methods: {
            // model開く
            show(exhibit, id) {
                this.exhibitdirt = JSON.parse(JSON.stringify(exhibit))
                this.itemindex = id
                window.console.log("this is exhibitdirt")
                window.console.log(this.exhibitdirt)
                this.$modal.show('dialog');
            },
            // model閉じる
            hide() {
                this.$modal.hide('dialog');
                this.$modal.hide('recommenddialog');
            },
            // 削除（今使てない）
            // removeItem(idx) {
            //     this.items.splice(idx, 1);
            // },
            linkOpen(url) {
                window.open(url,'_blank')
            },

            changedirt() {
                //展示物の詳細情報を更新
                window.console.log("this is item change")
                window.console.log(this.exhibitdirt)
                window.console.log(this.itemindex)
                this.$set(this.items,this.itemindex,this.exhibitdirt)
                window.console.log("item had changed")
                window.console.log(this.items)
                //その他の関連語を更新
                this.otherlist = []
                for (var item of this.items) {
                    this.otherlist = this.otherlist.concat(item.other)
                }
                window.console.log("this is otherlist")
                window.console.log(this.otherlist)
            },

            //展示物の推薦表示
            showRecommend(keyword, recommenditem) {
                this.recommendkey = keyword;
                this.recommend = recommenditem;
                this.isKeyword = false;
                this.isRecommend = true;
                window.console.log("widow will be change")
                window.console.log(this.recommendkey)
                window.console.log(this.keyword)
            },
            
            //重要が高い語
            showKeyword() {
                this.recommendkey = []
                this.recommend = []
                this.isKeyword = true;
                this.isRecommend = false;
            },

            //重要が高い語
            selectRecommend(recommendword) {
                window.console.log("dialog")
                window.console.log(recommendword)
                this.recommendkey = recommendword
                this.$refs.recommenderar.selectRecommendids(recommendword)
                if (this.recommendkey !== ""){
                    this.$modal.show('recommenddialog');
                }
            },
        },
        watch:{
            items () {
                this.$emit('itemsupdata', this.items)
            }
        }
    }
</script>

<style lang="css" scoped>
    .card-deck {margin:10px;margin-top:0px;}
    .Block {background-color:rgba(194, 71, 55, 0.8);position:absolute;width:19px; height:22px;float:left;font-size:11px;text-align:center;padding-top:5px;}
    .testBlock {background-color:rgba(182, 240, 76, 0.8);position:absolute;width:19px; height:22px;float:left;font-size:11px;text-align:center;padding-top:5px;}
    .VA{left:29px;}
    .VB{left:48px;}
    .VC{left:67px;}
    .VD{left:86px;}
    .VE{left:105px;}
    .VF{left:123px;}
    .VG{left:143px;}
    .VH{left:161px;}
    .VI{left:180px;}
    .VG{left:199px;}
    .VK{left:218px;}
    .VL{left:236px;}
    .VM{left:255px;}
    .VN{left:274px;}
    .H1{top:23px;}
    .H2{top:45px;}
    .H3{top:67px;}
    .H4{top:89px;}
    .H5{top:111px;}
    .H6{top:133px;}
    .H7{top:154px;}
    .H8{top:176px;}
    .H9{top:198px;}
    .H10{top:220px;}
    .H11{top:242px;}
    .H12{top:264px;}
    .H13{top:286px;}
    #basic-table { margin:10px;}
    #basic-table th{border:2px solid #ccc; padding:2px;width:30px;height:30px;text-align:center;}
    #basic-table td{border:2px solid #ccc; padding:2px;width:30px;height:30px;text-align:center;}

    .details_main{
        width: 1300px;
        height: 630px;
        margin: auto;
        margin-top: 3px;
    }

    .details_main .details_item{
        width: 940px;
        height: 630px;
        margin: auto;
        float: left;
    }

    .details_main .details_item .item-card{
        width: 200px;
        height: 315px;
        max-width: 180px;
        max-height: 315px;
        margin: auto;
        margin-left: 3px;
        margin-right: auto;
        padding: 4px;
        /* background-color: rgba(255, 233, 193, 0.836); */
        background-image: linear-gradient(to top, rgba(231, 225, 181, 0), rgb(235, 226, 106));
        float:left
    }
    
    .details_main .details_item .item-card:HOVER{ 
        -webkit-transition:border linear .2s,-webkit-box-shadow linear .5s; 
        border-color:rgba(37, 150, 241, 0.75); 
        -webkit-box-shadow:0 0 18px rgba(37, 150, 241,3); 
    } 

    /* .details_main .details_item .item-card  .itemname{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 14px;
        font-weight: bold;
    } */

    .details_main .details_item .item-card ul{
        list-style-type:none;
        margin: 0px;
        padding: 0px;
        text-align: center;
    }

    .details_main .details_item .item-card li{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        margin-bottom:1px;
    }

    .details_main .details_item .item-card span{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 11px;
        font-weight: bold;
        margin-bottom:1px;
    }

    .details_main .details_item .item-card .item-position{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 13px;
        font-weight: bold;
        margin-bottom:2px;
        float:  right;
    }

    .details_main .details_item :hover{
        cursor: grab;
    }
    .details_main .details_item :active{
        cursor:grabbing;
    }

    .details_main .details_other{
        width: 350px;
        height: 630px;
        margin-top: 8px;
        margin-left: 935px;
    }

    .details_main .details_other .map {
        width: 330px;
        height: 330px;
        margin: auto;
        /* margin-bottom:15px; */
        background-image: url(../../assets/img/map.jpg);
        background-size: 100% 100%;
        position: relative;
    }
    /* .details_main .details_other .recommend{
        width: 350px;
        height: 275px;
        margin: auto;
        margin-top: 20px;
        border-radius: 10px;
        border: rgb(250, 246, 238) solid 2px;
        background: rgb(250, 246, 238);
        text-align: center;
    } */

    /* .details_main .details_other .recommend span{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 15px;
        font-weight: bold;
        margin-top: 3px;
    } */
    /* .details_main .details_other .recommend .mainitem{
        width: 100px;
        height: 110px;
        max-height: 110px;
        margin: auto;
        margin-top: 6px;
        border-radius: 10px;
    } */

    /* .details_main .details_other .recommend .mainitem img{
        width: 40px;
        height: 40px;
    }

    .details_main .details_other .recommend .mainitem span{
        width: 90px;
        height: 10px;
        max-height: 10px;
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #666666;
        font-size: 3px;
        font-weight: bold;
        white-space:pre-wrap
    } */

    .details_main .details_other .other_keyword{
        width: 350px;
        height: 280px;
        margin: auto;
        margin-top: 20px;
        border-radius: 10px;
        border: rgb(250, 246, 238) solid 2px;
        background: rgb(250, 246, 238);
        text-align: left;
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 20px;
        font-weight: bold;
    }

    .details_main .details_other .other_keyword #keyword-coment{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 12px;
        font-weight: bold;
    }

    .details_main .details_other .other_keyword .keywords{
        width: 340px;
        height: 260px;
        margin: auto;
    }
    .details_main .details_other .other_keyword .keywords .keyword{
        margin: 4px;
        float: left;
    }

    .details_main .details_other .other_keyword .keywords .keyword a{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #666666;
        font-size: 18px;
        font-weight: bold;
        word-break: keep-all;
    }

    .details_main .details_other .recommend-items{
        width: 350px;
        height: 280px;
        margin: auto;
        margin-top: 20px;
        border-radius: 10px;
        border: rgb(250, 246, 238) solid 2px;
        background: rgb(250, 246, 238);
        text-align: left;
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 20px;
        font-weight: bold;
    }
    .details_main .details_other .recommend-items .recommendkey{
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #f03b3b;
        font-size: 21px;
        font-weight: bold;
    }

    .details_main .details_other .recommend-items .recommend-eare{
        width: 350px;
        height: 260px;
        margin-top: 5px;
        text-align: center;
    }
    
    .details_main .details_other .recommend-items .recommend-eare .recommend-item{
        width: 110px;
        height: 120px;
        max-width: 110px;
        max-height: 120px;
        border-radius: 10px;
        margin: 2px;
        float: left;
        text-align: center;
        /* border-radius: 10px;
        border: rgb(100, 120, 235) solid 2px;
        background: rgb(100, 120, 235); */
    }

    .details_main .details_other .recommend-items .recommend-eare .recommend-item .item_img{
        width: 60px;
        height: 60px;
        margin: auto;
    }

    .details_main .details_other .recommend-items .recommend-eare .recommend-item .item_img img{
        width: 100%;
        height: 100%;
    }
/* 
    .details_main .details_other .recommend-items .recommend-eare .recommend-item .item_img span{
        width: 90px;
        height: 40px;
        max-height: 40px;
        font-weight: bold;
        word-wrap: break-word
    } */

    .details_main .details_other .recommend-items .recommend-eare .recommend-item .item_text{
        width: 110px;
        height: 50px;
        min-height: 50px;
        margin: auto;
        margin-top: 2px;
        text-align: center;
        /* border-radius: 10px;
        border: rgb(200, 206, 240) solid 2px;
        background: rgb(200, 206, 240); */
    }

    .details_main .details_other .recommend-items .recommend-eare .recommend-item .item_text ul{
        list-style-type:none;
        margin: 0px;
        padding: 0px;
        text-align: center;
    }

    .details_main .details_other .recommend-items .recommend-eare .recommend-item .item_text li{
        text-align: center;
        font-family: "Yu Gothic Medium", "游ゴシック Medium", "YuGothic",
          "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
        color: #333333;
        font-size: 13px;
        font-weight: bold;
        margin-bottom:1px;
    }
</style>